export const IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS = {
	oneMonthBefore: "identification_document_1m_before",
	threeMonthsBefore: "identification_document_3m_before",
	onExpiry: "identification_document_expiry",
} as const;

export const IDENTIFICATION_DOCUMENT_REMINDER_MONTH_OFFSETS: Record<
	string,
	number
> = {
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.oneMonthBefore]: 1,
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.threeMonthsBefore]: 3,
	[IDENTIFICATION_DOCUMENT_REMINDER_TYPE_KEYS.onExpiry]: 0,
};
